import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const CameraIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue439'}</MuiIcon>
    );
}
